import { mediaQueriesMixin } from '@/mixins/mediaQueries';

export const ghostWriterArticleMixin = {
    mixins: [mediaQueriesMixin],
    data() {
        const baseUrl = this.getBaseUrl();
        const apiHomePageUrl = `ghost-writer/host/${this.$globalConstants.host['name']}/language/${this.$globalConstants.host['language_code']}/content`;
        const apiBaseUrl = `ghost-writer/host/${this.$globalConstants.host['name']}/articles`;
        const apiCategoryBaseUrl = 'ghost-writer/categories';

        return {
            apiHomePageUrl: baseUrl + apiHomePageUrl,
            apiBaseUrl: baseUrl + apiBaseUrl,
            apiCategoryBaseUrl: baseUrl + apiCategoryBaseUrl,
        };
    },
    methods: {
        updateMetaTags(data) {
            if (!data || !data['seo_title']) {
                return;
            }

            document.title = data['seo_title'];

            if (!data || !data['seo_description']) {
                return;
            }

            let metaTag = document.querySelector('meta[name="description"]');

            if (!metaTag) {
                const headElement = document.getElementsByTagName('head')[0];
                const description = document.createElement('meta');
                description.setAttribute('name', 'description');
                headElement.append(description);
                metaTag = document.querySelector('meta[name="description"]');
            }

            metaTag.setAttribute('content', data['seo_description']);
        },
        async getArticle() {
            const slug = this.$route.params.article || this.slug;
            if (!slug && this.isNonDefaultLanguage === false) return;
            const page = parseInt(this.$route.query.page) || 1;

            const url = this.isNonDefaultLanguage
                ? this.apiHomePageUrl
                : `${this.apiBaseUrl}/${slug}?page=${page}`;

            try {
                const response = await axios.get(url);
                const data = this.isNonDefaultLanguage
                    ? response.data['gw_article_content']
                    : response.data;

                if (!data) return;
                data['ranking_providers'] = await this.getProviderProps(data);
                this.article = data;
                this.loaded = true;
                this.updateMetaTags(data);
            } catch (e) {
                console.error(e);
                this.redirectToHomePage();
            }
        },
        async getCategory() {
            const id = this.getCategoryId();
            const page = parseInt(this.$route.query.page) || 1;
            const response = await axios.get(
                `${this.apiCategoryBaseUrl}/${id}?page=${page}`
            );
            if (!response.data || !response.data['gw_article_content']) return;
            const data = response.data['gw_article_content'];

            try {
                data['review_page_count'] = this.isMobile()
                    ? data['ranking_providers']['mobile_page_count']
                    : data['ranking_providers']['desktop_page_count'];
            } catch (e) {
                data['review_page_count'] = null;
            }

            try {
                data['ranking_providers'] = await this.getProviderProps(data);
                this.article = data;
                this.loaded = true;
                this.updateMetaTags(data);
            } catch (e) {
                console.error(e);
                this.redirectToHomePage();
            }
        },
        getCategoryId() {
            try {
                if (this.categoryId) return this.categoryId;
                let path = window['location']['pathname'];
                if (path !== '/') {
                    path = path.endsWith('/') ? path.slice(0, -1) : path;
                }
                if (!this.$globalConstants.host['is_default_language']) {
                    path = path.replace(window['__language_path__'], '');
                }
                return window['__host__']['category_tree_ids'][path] || null;
            } catch (e) {
                return null;
            }
        },
        getLanguage() {
            if (!this.$globalConstants.host['category_tree_languages']) {
                return null;
            }

            if (!this.$globalConstants.host['language_code']) {
                return null;
            }

            const supportedLanguages =
                this.$globalConstants.host['category_tree_languages'];
            const currentLanguage = this.$globalConstants.host['language_code'];
            const index = supportedLanguages.findIndex(
                (item) => item['iso_code'] === currentLanguage
            );

            return supportedLanguages[index];
        },
        processProviderProps(providerProps) {
            let providerProp = '';
            let isPartnerDescMarketingProp = true;

            if (!providerProps || providerProps.length === 0) {
                return {
                    marketing: {},
                };
            }

            try {
                const settings = this.$globalConstants.components.Settings;
                providerProp = settings['partnerDescProp'];
                isPartnerDescMarketingProp =
                    settings['isPartnerDescMarketingProp'];
            } catch (e) {
                console.log('Provider Props Setting Missing');
            }

            if (!providerProp) {
                providerProp = 'members';
                isPartnerDescMarketingProp = true;
            }

            if (
                isPartnerDescMarketingProp !== false ||
                isPartnerDescMarketingProp !== true
            ) {
                isPartnerDescMarketingProp = true;
            }

            const marketingProps = providerProps['marketing'] || {};

            // handle discount button props
            if (marketingProps['discount button']) {
                providerProps['marketing']['discount btn'] =
                    marketingProps['discount button'];
            }

            if (isPartnerDescMarketingProp) {
                providerProps['marketing']['members'] =
                    marketingProps[providerProp];
            } else {
                providerProps['marketing']['members'] =
                    providerProps[providerProp];
            }

            return providerProps;
        },
        async getProviderProps(data) {
            let partners = [];
            if (!data['ranking_providers']) return partners;
            let providers = [];

            if (this.isMobile()) {
                providers = data['ranking_providers']['mobile'] || [];
            } else {
                providers = data['ranking_providers']['desktop'] || [];
            }

            providers = Object.values(providers);

            for (const key in providers) {
                partners.push({
                    ...this.processProviderProps(
                        providers[key]['provider_properties']
                    ),
                    ...providers[key],
                });
            }

            return partners;
        },

        async loadData() {
            this.loaded = false;
            this.article = {};

            if (this.useCategoryEndpoint) {
                await this.getCategory();
                return;
            }

            await this.getArticle();
        },
        getBaseUrl() {
            return window.__api_base_url__.replace('v2', '');
        },
        redirectToHomePage() {
            if (window.location.pathname === '/') return;
            window.location = '/';
        },
    },
    beforeMount() {
        this.loadData();
    },
    watch: {
        $route() {
            this.loadData();
        },
    },
};
